import React, { useContext, useEffect, useRef, useState } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import language from "../../nls/language.json";
import Context from "../../context/Context";
import { Tab, Tabs } from "react-bootstrap";
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import { WagonTableRadio } from "../wagon/components/WagonTableRadio";
import blogFetch from "../../axios/config";
import './wagonApproved.css'
import { WagonApprovedCards } from "./components/cardWagonApproved";
import { InputGroup, Button, Form } from "react-bootstrap"
import { WagonApprovedCardsFinalizado } from "./components/CardWagonApprovedFinalizado";

const LIBERADO = "LIBERADO"
const ENTRADA = "ENTRADA"
const CURVANDO = "CURVANDO"
const FINALIZADO = "FINALIZADO"
const APROVADO = "APROVADO"

export const WagonApproved = () => {

  const [idScreen, setIdScreen] = useState(0);

  const [time, setTime] = useState("");
  const [fornoEtapa, setFornoEtapa] = useState(0);
  const [color, setColor] = useState("");
  const abortControllerRef = useRef(null);

  const {
    selectedCountry,
    selectedFurnace,
    setSearchWagon,
    searchWagon,
    status,
    setStatus,
    setConfirmedWagon,
    confirmedWagon,
    setLoading,
  } = useContext(Context);


  const getConfirmedWagon = async (status, selectedFurnace) => {
    setConfirmedWagon([]);
    setLoading(true);
    try {

      // Cancela a requisição anterior, se existir
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Cria um novo AbortController e armazena a referência
      const controller = new AbortController();
      abortControllerRef.current = controller;

      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornosPecas?status=${status}&furnace=${selectedFurnace}`,
        { signal: controller.signal } // Passanodo o sinal para permitir o cancelament
      );

      const url = data.map((item) => {
        if (item.wagonInfo.vagao_Image)
          item.wagonInfo.vagao_Image += "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2033-06-06T23:22:22Z&st=2023-06-06T15:22:22Z&spr=https,http&sig=AmNdgNEWKNvsjgz%2BfwYJKb7l1nBWV%2F5V34UqWHQ0n%2FY%3D";
        return item;
      });

      setConfirmedWagon(url);
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    const controller = new AbortController();

    if (status && selectedFurnace) getConfirmedWagon(status, selectedFurnace);

    return () => controller.abort();
  }, [status, selectedFurnace]);


  useEffect(() => {
    if (!time) return;
    getTime(time);
    const interval = setInterval(() => {
      getTime(time);
    }, 60 * 1000);
    return () => clearInterval(interval);
  }, [time])

  const getHourFurnace = async (statusWagon) => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_VagoesFornos/hour/${statusWagon}?furnace=${selectedFurnace}`);
      const next = Array.isArray(data) ? data[0] : null;
      setTime(next?.dateTime ?? "");
      setFornoEtapa(next?.fornoEtapa ?? 0);
    } catch (error) {
      setTime("");
    }
  }

  const statusOut = {
    LIBERADO: "PRÓXIMA ENTRADA",
    ENTRADA: "APONTAR CURVADO",
    CURVANDO: "PRÓXIMA SAÍDA",
    FINALIZADO: "APROVADO"
  }

  const getTime = (times) => {
    const dataTimes = new Date(times);
    const date = new Date();
    const dataTimesMinutes = (dataTimes - date) / (1000 * 60);
    switch (true) {
      case dataTimesMinutes <= 5:
        setColor('color-time-red')
        break;
      case dataTimesMinutes > 5 && dataTimesMinutes <= 15:
        setColor('color-time-orange')
        break;
      case dataTimesMinutes > 15 && dataTimesMinutes <= 25:
        setColor('color-time-yellow')
        break;
      case dataTimesMinutes > 25:
        setColor('color-time-green')
        break;
    }
  }

  const body = (status) => {
    switch (idScreen) {
      case 1:
        if (status != LIBERADO) {
          getHourFurnace(LIBERADO)
          setStatus(LIBERADO)
        }
        return <WagonApprovedCards
          confirmedWagon={filteredWagon}
          status={status}
          time={time}
          fornoEtapa={fornoEtapa}
          statusOut={statusOut}
          color={color}
        />;
      case 2:
        if (status != ENTRADA) {
          getHourFurnace(ENTRADA)
          setStatus(ENTRADA)
        }
        return <WagonApprovedCards
          confirmedWagon={filteredWagon}
          status={status}
          time={time}
          fornoEtapa={fornoEtapa}
          statusOut={statusOut}
          color={color}
        />;
      case 4:
        if (status != FINALIZADO)
          setStatus(FINALIZADO)

        return <WagonApprovedCardsFinalizado status={status} confirmedWagon={filteredWagon} />;
      default:
        return <></>
    }
  };

  const handleTitle = (icon, title) => {
    return (
      <div className="d-flex flex-column align-items-center">
        {icon}
        <span className="mt-1 text-light fw-bold">{title.toUpperCase()}</span>
      </div>
    )
  }

  const iconScaleDashboard = 1.3


  const filteredWagon = confirmedWagon.filter(({ wagon, wagonInfo }) => {
    const vagaoSerial = wagonInfo.vagao_Serial?.toString() || '';
    const furnaceSerial = selectedFurnace?.toString() || '';
    
    const firstLetterVagao = vagaoSerial.charAt(0).toLowerCase();
    const lastLetterFurnace = furnaceSerial.charAt(furnaceSerial.length - 1).toLowerCase();
    
    return wagon.some(
      item => (
        item.ordem_Serial
          .toString()
          .toLowerCase()
          .includes(searchWagon.toLowerCase())
        ||
        vagaoSerial
          .toLowerCase()
          .includes(searchWagon.toLowerCase())
      )
    )
    &&
    firstLetterVagao === lastLetterFurnace;
  });

  return (
    <>
      <Navbar />
      <Sidebar />

      <div className={`div-row-button dashboard-tabs`}>

        <div>
          <WagonTableRadio reset={() => { }} />
        </div>

        <Tabs
          defaultActiveKey={0}
          className="mb-1"
          onSelect={(e) => setIdScreen(Number(e))}
          fill
        >
          <Tab
            eventKey={1}
            title={handleTitle(<LooksOneIcon sx={{
              transform: `scale(${iconScaleDashboard})`,
              color: "#6aa84f",
            }} />, language[selectedCountry.name].vagoesAprovados.buttonsAprovado.entrada)}
          />
          <Tab
            eventKey={2}
            title={handleTitle(<LooksTwoIcon sx={{
              transform: `scale(${iconScaleDashboard})`,
              color: "#6aa84f"
            }} />, language[selectedCountry.name].vagoesAprovados.buttonsAprovado.curvando)}
          />
          {/* <Tab
            eventKey={3}
            title={handleTitle(<Looks3Icon sx={{
              transform: `scale(${iconScaleDashboard})`,
              color: "#6aa84f"
            }} />, language[selectedCountry.name].vagoesAprovados.buttonsAprovado.saida)}
          /> */}
          <Tab
            eventKey={4}
            title={handleTitle(<Looks4Icon sx={{
              transform: `scale(${iconScaleDashboard})`,
              color: "#6aa84f"
            }} />, language[selectedCountry.name].vagoesAprovados.buttonsAprovado.aprovado)}
          />
        </Tabs>

        {idScreen != 4 && (
          <InputGroup className="my-2">
            <Form.Control
              placeholder="Buscar Ordem Serial ou Código do Vagão"
              value={searchWagon}
              onChange={({ target }) => setSearchWagon(target.value)}
            />
            <Button className="status-molde-button-form">
              Buscar
            </Button>
          </InputGroup>
        )}

      </div>
      <div
        className={`app_body`}
        style={{ padding: 0, top: 85 }}
      >
        <div style={{ marginBottom: 20 }}>{body(status)}</div>
      </div>
    </>
  )
}